import React, { Component } from 'react';
import { ToastContainer } from 'react-toastify';

import InfoModal from './app/shared/info-modal/components/info-modal';

import 'react-toastify/dist/ReactToastify.css';
import './common/styles/app.css';
import './libs/bootstrap/css/bootstrap.min.css';

class App extends Component {
  render() {
    const childrenWithProps = React.Children.map(this.props.children, child =>
      React.cloneElement(child, {
        currentPath: this.props.currentPath,
      })
    );
    return (
      <div className="main-container">
        <ToastContainer autoClose={10000} />
        <InfoModal />
        <div className="main-container__content">{childrenWithProps}</div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js